import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { editClient } from '../../../actions';
import Modal, { ModalBody, ModalFooter } from '../ui/Modal';
import Button from '../ui/Button';
import { TextField } from '../ui/FormField';

// Redesign of newadmin/EditClientModal.js — same editClient(state, clientId)
// thunk and the same moveClient callback (provided by ApplicantListCard).
const EditClientModal = ({ open, onClose, client, clientId, onMoveClient }) => {
    const dispatch = useDispatch();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [firebaseId, setFirebaseId] = useState('');

    // Sync form fields from the selected client (port of componentDidUpdate).
    useEffect(() => {
        if (open && client) {
            setName(client.name || '');
            setEmail(client.email || '');
            setMobile(client.mobile || '');
            setFirebaseId(client.firebase_id || '');
        }
    }, [open, client]);

    const formSubmit = (e) => {
        e.preventDefault();
        dispatch(editClient({ name, email, mobile, firebase_id: firebaseId }, clientId));
        onClose();
    };

    return (
        <Modal open={open} onClose={onClose} title="Edit Client" size="lg">
            <form onSubmit={formSubmit} className="flex flex-col flex-1 min-h-0 overflow-hidden">
                <ModalBody className="flex-1">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <TextField
                            label="Client Name"
                            required
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Client Name"
                        />
                        <TextField
                            label="Client Mobile"
                            required
                            value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                            placeholder="Client Mobile"
                        />
                        <TextField
                            label="Client Email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Client Email"
                            className="sm:col-span-2"
                        />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button variant="secondary" onClick={onClose}>
                        Close
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            onMoveClient();
                            onClose();
                        }}
                    >
                        Move Client
                    </Button>
                    <Button type="submit">Edit Client</Button>
                </ModalFooter>
            </form>
        </Modal>
    );
};

export default EditClientModal;
